import { render, staticRenderFns } from "./createPost.vue?vue&type=template&id=23a6dafa"
import script from "./createPost.vue?vue&type=script&lang=js"
export * from "./createPost.vue?vue&type=script&lang=js"
import style0 from "./createPost.vue?vue&type=style&index=0&id=23a6dafa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports